var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportMerchantTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.844,
    height: 25.355,
    viewBox: "0 0 26.844 25.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3109",
    "data-name": "Groupe 3109",
    transform: "translate(6686.978 2782.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2505",
    "data-name": "Groupe 2505",
    transform: "translate(-6686.978 -2779.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_create_2970141",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2048",
    "data-name": "Groupe 2048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_480",
    "data-name": "Trac\\xE9 480",
    d: "M30.269,8.446,24.611,2.764a.913.913,0,0,0-.623-.264h-10.5a.885.885,0,0,0-.887.887V24.413a.885.885,0,0,0,.887.887H29.67a.885.885,0,0,0,.887-.887V9.069A.951.951,0,0,0,30.269,8.446ZM24.084,4.73l4.2,4.2h-4.2Zm-9.734,18.8V4.25h7.984V9.812a.885.885,0,0,0,.887.887h5.562V23.5H14.35Z",
    transform: "translate(-12.6 -2.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "logout",
    d: "M3.384,3.981H16.848a1,1,0,0,1,0,1.99H3.384L5.656,8.253a1,1,0,0,1,0,1.407.987.987,0,0,1-1.4,0L.292,5.681a1,1,0,0,1-.29-.7s0,0,0-.007,0,0,0-.006A.992.992,0,0,1,.077,4.6a1.009,1.009,0,0,1,.215-.324L4.255.292a.987.987,0,0,1,1.4,0,1,1,0,0,1,0,1.407Z",
    transform: "translate(-6660.134 -2782.303) rotate(90)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportMerchantTicket);
export default __webpack_public_path__ + "static/media/export-merchant-ticket.9c6b8f836e8d347e155357cf966913cf.svg";
export { ForwardRef as ReactComponent };